import React, { useCallback, useState } from 'react'
import 'react-toastify/dist/ReactToastify.css'
import { LogsPopup } from '../../Organisms/Popups/LogsPopup'
import settingGreen from './../../../imgs/SettingGreen.png'
import { formatDate } from '../../../Services/dateFormat'
import ListPage from '../../Organisms/ListPage/ListPage'
import { LogsHeader } from './LogsHeader'
import { Api } from '../../../Services/Api'
import TableNavigation from '../../TableNavigation/TableNavigation'

export function getAllFlow(search = null) {
    const searchParams = new URLSearchParams(search)
    const queryString = search ? searchParams.toString() : ''
    const limit = 10
    return Api()
        .get(`api/logs/all?limit=${limit}&${queryString}`)
        .then((response) => response)
}

export const LogsList = () => {
    const [search, setSearch] = useState({
        page: 1,
        flowName: '',
        ip: '',
        status: 'all',
    })
    // const [page, setPage] = useState(1)
    const setPage = (page) => {
        setSearch({ ...search, page: page })
        setTriggerRefresh((v) => ++v)
    }
    const [totalPages, setTotalPages] = useState(1)
    const [showPopup, setShowPopup] = useState(false)
    const [row, setRow] = useState(null)

    const [triggerRefresh, setTriggerRefresh] = useState(0)

    const onSearch = useCallback((_search) => {
        setSearch(_search)
        setTriggerRefresh((v) => ++v)
    }, [])

    const showSettingsAction = useCallback(
        (item) => {
            setShowPopup(true)
            setRow(item.data)
        },
        [setRow, setShowPopup],
    )

    const activityLogTableColumn = [
        { field: 'flowName', filter: true },
        { field: 'requestIp', filter: true },
        {
            field: 'status',
            filter: true,
            valueGetter: (params) => {
                return !params.data.status ? 'Success' : 'Fail'
            },
        },
        { field: 'requestedUrl', filter: true },
        {
            field: 'createdAt',
            filter: true,
            sort: true,
            valueGetter: (params) => {
                return formatDate(new Date(params.data.createdAt))
            },
        },
        {
            field: 'Actions',
            cellRenderer: (params) => {
                return (
                    <img
                        src={settingGreen}
                        onClick={() => showSettingsAction(params)}
                        style={{
                            cursor: 'pointer',
                            paddingRight: '5px',
                            paddingLeft: '15px',
                        }}
                    />
                )
            },
        },
    ]

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                flex: '1',
                gap: '10px',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}
        >
            {showPopup && <LogsPopup setLogsPopup={setShowPopup} row={row} />}
            <ListPage
                title="Logs"
                triggerCall={triggerRefresh}
                dataModelCall={() =>
                    getAllFlow(search).then((data) => {
                        setTotalPages(data.totalPages)
                        return data.logs
                    })
                }
                tableColumns={activityLogTableColumn}
                showSettingsAction={showSettingsAction}
                HeaderComponent={() => (
                    <LogsHeader onSearch={onSearch} search={search} />
                )}
            />
            <TableNavigation
                pageCount={totalPages}
                page={search.page}
                setPage={setPage}
                rowCount={search.page}
                callData={(_page) => {
                    setPage(_page)
                }}
            />
        </div>
    )
}
